import { makeTitleCellForRow } from "./helper.js";
import RowTitleRenderer from "../../../RowTitleRenderer/RowTitleRenderer.js";

/**
 * Visit an Excel report to render the titles of its rows
 */
export default class ExcelRowTitleRenderer extends RowTitleRenderer {
	visitAbstractRow(row) {
		return makeTitleCellForRow({
			row,
			content: this._itemTitleRenderer(row),
		});
	}

	// eslint-disable-next-line sonarjs/no-identical-functions -- we should fix that
	visitGroupRow(row) {
		return makeTitleCellForRow({
			row,
			content: this._itemTitleRenderer(row),
		});
	}

	visitAccountRow(row) {
		return makeTitleCellForRow({
			row,
			content: [
				this._itemTitleRenderer(row),
				this._dimensionsRenderer(row),
			]
				.join(" ")
				.trim(),
		});
	}

	// eslint-disable-next-line sonarjs/no-identical-functions -- we should fix that
	visitStaticReportRow(row) {
		return makeTitleCellForRow({
			row,
			content: [
				this._itemTitleRenderer(row),
				this._dimensionsRenderer(row),
			]
				.join(" ")
				.trim(),
		});
	}

	visitSpacerRow(row) {
		return makeTitleCellForRow({
			row,
			content: "",
		});
	}

	// eslint-disable-next-line sonarjs/no-identical-functions -- we should fix that
	visitTextRow(row) {
		return makeTitleCellForRow({
			row,
			content: this._itemTitleRenderer(row),
		});
	}

	_collapseExpandIconRenderer() {
		return "";
	}
}
